import { gql } from '@apollo/client'

export const FINISH_TEST_SESSION = gql`
  mutation FinishTestSession($inputData: FinishTestSessionInput!) {
    finishTestSession(inputData: $inputData) {
      id
    }
  }
`
